module.exports = __webpack_public_path__ + "fonts/4e8e72e4e8738309a5d7910dca84a883.svg";